// 'use client'

// import { logout } from '@/actions/auth/logout'
// import { LogOut } from 'lucide-react'
// import { useRouter } from 'next/navigation'

// export function LogoutButton() {
//   const router = useRouter()

//   const handleLogout = async () => {
//     await logout()
//     router.push('/')
//   }

//   return (
//     <button
//       type="button"
//       onClick={handleLogout}
//       className="p-0.5 hover:bg-gray-500/25 w-full cursor-pointer flex gap-2 items-center text-sm text-red-500 font-medium"
//     >
//       <LogOut className="text-red-500 size-4" /> Sair
//     </button>
//   )
// }

'use client'

import { LoaderCircle, LogOut } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'
import { logout } from '@/actions/auth/logout'

export function LogoutButton() {
  const router = useRouter()
  const [isLoading, startTransition] = useTransition()

  async function handleLogout() {
    startTransition(async () => {
      await logout()
      router.push('/')
    })
  }

  return (
    <button
      className="group flex w-full cursor-pointer items-center gap-3 rounded-xl p-3 transition-all duration-200 hover:bg-red-50/80"
      onClick={handleLogout}
      type="button"
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-linear-to-br from-red-500 to-red-600 text-white shadow-xs transition-all duration-200 group-hover:shadow-md">
        {isLoading ? (
          <LoaderCircle className="h-4 w-4 animate-spin" />
        ) : (
          <LogOut className="h-4 w-4" />
        )}
      </div>
      <div className="flex-1 text-left">
        <p className="font-medium text-gray-900 text-sm">Sair</p>
        <p className="mt-0.5 text-gray-500 text-xs">Encerrar sessão atual</p>
      </div>
    </button>
  )
}
